var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plk_javascript"},[_c('Menu'),_c('div',{staticClass:"javascript"},[_c('codemirror',{attrs:{"options":_vm.cmOptions},model:{value:(_vm.code),callback:function ($$v) {_vm.code=$$v},expression:"code"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }